import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-07-19
 * @brief SEI Management - 승인관리 개발
 *
 ********************************************************************/
//
import { useOutletContext } from "react-router-dom";
import SiteApprovalManageMent from "./SiteApproval";
import NewSubscriberApprovalManageMnet from "./UserApproval";
function ApprovalMain() {
    const { handleOpenPop } = useOutletContext();
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "box-wrap" }, { children: _jsx("div", Object.assign({ className: "content-wrap" }, { children: _jsxs("div", Object.assign({ className: "l-divide" }, { children: [_jsx("article", Object.assign({ className: "flex-1" }, { children: _jsx(NewSubscriberApprovalManageMnet, { handleOpenPop: handleOpenPop }) })), _jsx("article", Object.assign({ className: "flex-2" }, { children: _jsx(SiteApprovalManageMent, { handleOpenPop: handleOpenPop }) }))] })) })) })) }));
}
export default ApprovalMain;
